// extracted by mini-css-extract-plugin
export default {"returnBar":"style__returnBar___JP_7b","title":"style__title___RhBsW","animateIn":"style__animateIn___ih63w"};